import * as req from 'api/actions';
import * as c from './constant';

export const getTransactionList = (payload = { module_type: 'HC' }, callback) =>
  req.list(
    c.GET_TRANSACTION,
    'api/v1/administrators/transaction_histories/',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback
  );

export const tagAsPrinted = (id, payload, callback) =>
  req.update(
    c.TAG_AS_PRINTED,
    `api/v1/administrators/transaction_histories/health_certificate/${id}/tag_as_printed`,
    payload,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const tagAsReceived = (id, payload, callback) =>
  req.update(
    c.TAG_AS_RECIVED,
    `api/v1/administrators/transaction_histories/health_certificate/${id}/tag_as_received`,
    payload,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const clearTransaction = () => req.setList(c.GET_TRANSACTION, []);

export const startAssessment = (id, callback) =>
  req.update(
    c.START_ASSESSMENT,
    `api/v1/administrators/transaction_histories/${id}/start_assessment`,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const assessReceipt = (id, payload, callback) =>
  req.update(
    c.ASSESS_RECEIPT,
    `/api/v1/administrators/transaction_histories/${id}/assess_payment_receipt`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const checkPermit = (payload, callback) =>
  req.list(
    c.OHP_CHECK,
    `api/v1/administrators/transaction_histories/health_certificate/certificate_number/check`,
    payload,
    callback
  );

export const updateTransaction = (id, payload, callback) =>
  req.update(
    c.UPDATE_TRANSACTION,
    `api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const approveTransaction = (id, payload, callback) =>
  req.update(
    c.APPROVE_TRANSACTION,
    `api/v1/administrators/transaction_histories/health_certificate/${id}/approve`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const rejectTransaction = (id, payload, callback) =>
  req.update(
    c.REJECT_TRANSACTION,
    `api/v1/administrators/transaction_histories/health_certificate/${id}/reject`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const cardColorChange = (id, payload, callback) =>
  req.update(
    c.CHANGE_COLOR,
    `api/v1/administrators/transaction_histories/health_certificate/${id}/change_color`,
    payload,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getSettings = (card_type, callback) =>
  req.item(c.GET_SETTINGS, `/api/v1/administrators/ohp_settings`, callback, {
    card_type,
  });

export const updatedHealthStatus = (id, payload, callback) =>
  req.update(
    c.UPDATE_TEST_STATUS,
    `api/v1/administrators/transaction_histories/health_certificates/findings/${id}`,
    payload,
    callback
  );

export const getBusinessEstablishmentsList = (payload, callback) =>
  req.list(
    c.GET_BUSINESS_ESTABLISMENT,
    'api/v1/administrators/business_establishments',
    payload,
    callback
  );

export const getBusinessEstablishmentsList2 = (payload, callback) =>
  req.list(
    c.GET_BUSINESS_ESTABLISMENT_TWO,
    'api/v1/administrators/transaction_histories/health_certificate/business_establishment/list',
    payload,
    callback
  );

export const updateOhp = (id, payload, callback) =>
  req.update(
    c.EDIT_OHP,
    `api/v1/administrators/transaction_histories/health_certificate/${id}/update`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const getInstitutionList = (payload, callback) =>
  req.list(
    c.GET_INSTITUTION,
    'api/v1/administrators/institutions_listing',
    payload,
    callback
  );

export const getWorkDescriptionList = (payload, callback) =>
  req.list(
    c.GET_WORK_DESCRIPTION,
    'api/v1/administrators/professions_listing',
    payload,
    callback
  );

export const updateBusinessEst = (transactionId, id, payload, callback) =>
  req.update(
    c.UPDATE_BUSINESS_EST,
    `api/v1/administrators/transaction_histories/health_certificate/${transactionId}/business_establishment/${id}`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const removeBusinessEst = (id, businessId, payload, callback) =>
  req.remove(
    c.REMOVE_BUSINESS_EST,
    `api/v1/administrators/transaction_histories/health_certificate/${id}/business_establishment/${businessId}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );

export const createLineBusiness = (transId, payload, callback) =>
  req.create(
    c.CREATE_BUSINESS_EST,
    `api/v1/administrators/transaction_histories/health_certificate/${transId}/business_establishment`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getCitizenshipList = (payload, callback) =>
  req.list(
    c.GET_CITIZENSHIP,
    'api/v1/administrators/citizenship',
    payload,
    callback
  );

export const getAppointmentLogs = (id, payload, callback) =>
  req.list(
    c.GET_APPOINTMENT_LOGS,
    `api/v1/administrators/transaction_histories/health_certificate/${id}/logs`,
    payload,
    callback
  );

// for appointments

export const getAppointmentsList = (payload, callback) =>
  req.list(
    c.GET_APPOINTMENTS_LIST,
    'api/v1/administrators/appointments',
    payload,
    callback
  );

export const showAppointment = (id, payload, callback) =>
  req.item(
    c.SHOW_APPOINTMENTS,
    `api/v1/administrators/appointments/${id}`,
    payload,
    callback
  );

export const updateAppointment = (id, payload, callback) =>
  req.update(
    c.UPDATE_APPOINTMENT,
    `api/v1/administrators/transaction_histories/health_certificate/${id}/update_appointment?appointment_id=${payload}`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const initialApprove = (id, payload, callback) =>
  req.update(
    c.INITIAL_APPROVE,
    `api/v1/administrators/transaction_histories/health_certificate/${id}/initial/approve`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const initialReject = (id, payload, callback) =>
  req.update(
    c.INITIAL_REJECT,
    `api/v1/administrators/transaction_histories/health_certificate/${id}/initial/reject`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );
